import PropTypes from "prop-types";
import React from "react";
import Select from "react-select";

import { createClassNameString } from "../utils";

import "./styles.scss";

// Uses a styled version of 'react-select', see https://react-select.com

export const Dropdown = ({
  cacheOptions,
  children,

  className,
  defaultOptions,
  error,

  filterOptions,
  getValue,

  isClearable,
  isDisabled,
  isFocused,
  isLoading,

  isMulti,
  isSearchable,
  loadingMessage,

  loadOptions,
  menuPlacement,

  menuPosition,
  name,
  noOptionsMessage,

  onBlur,
  onChange,

  onFocus,
  onKeyDown,
  options,
  placeholder,

  setValue,
  value,
  ...props
}) => {
  // Since react-select does not provider a standard event to onChange
  // we are created a faux event here to pass into onChange
  const handleChange = (event) => {
    if (!event) {
      onChange({
        target: {
          name: name,
          value: null,
        },
      });
    }
    // handles multi select
    else if (Array.isArray(event)) {
      onChange({
        target: {
          name: name,
          value: event,
        },
      });
    }
    // if not multi select and event has a truthy value
    else {
      const value = event.value;

      onChange({
        target: {
          name: name,
          value: value,
        },
      });
    }
  };

  const safeGetValue = () => {
    if (Array.isArray(value)) {
      return value;
    }
    if (value && value.value !== null && typeof value.value !== "undefined") {
      return value;
    }

    return null;
  };

  return (
    <Select
      cacheOptions={cacheOptions}
      className={createClassNameString(["apti-CL", "apti-Dropdown", className, error && "error"])}
      classNamePrefix="react-select"
      defaultOptions={defaultOptions}
      filterOption={filterOptions}
      getValue={getValue}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isLoading={isLoading}
      isMulti={isMulti}
      isSearchable={isSearchable}
      loadingMessage={loadingMessage}
      loadOptions={loadOptions}
      menuPlacement={menuPlacement}
      menuPosition={menuPosition}
      name={name}
      noOptionsMessage={noOptionsMessage}
      onBlur={onBlur}
      onChange={handleChange}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      options={options}
      placeholder={placeholder}
      setValue={setValue}
      value={safeGetValue()}
      {...props}
    >
      {children}
    </Select>
  );
};

Dropdown.propTypes = {
  cacheOptions: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.element,
  ]),

  className: PropTypes.string,
  defaultOptions: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  error: PropTypes.bool,

  filterOptions: PropTypes.func,
  getValue: PropTypes.func,

  isClearable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  isLoading: PropTypes.bool,

  isMulti: PropTypes.bool,
  isSearchable: PropTypes.bool,
  loadingMessage: PropTypes.string,

  loadOptions: PropTypes.array,
  menuPlacement: PropTypes.oneOf(["bottom", "top"]),

  name: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  onBlur: PropTypes.func,

  onChange: PropTypes.func,

  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  setValue: PropTypes.func,
  value: PropTypes.object,
};

Dropdown.defaultProps = {
  cacheOptions: false,
  children: <></>,

  className: undefined,
  defaultOptions: [],
  error: false,

  filterOptions: undefined,
  getValue: () => {},

  isClearable: false,
  isDisabled: false,
  isFocused: false,
  isLoading: false,

  isMulti: false,
  isSearchable: true,
  loadingMessage: undefined,

  loadOptions: undefined,
  menuPlacement: "bottom",

  name: "",
  noOptionsMessage: undefined,
  onBlur: () => {},

  onChange: () => {},

  onFocus: () => {},
  onKeyDown: () => {},
  options: [],
  placeholder: undefined,
  setValue: () => {},
  value: undefined,
};
